// extracted by css-extract-rspack-plugin
export default {"headerWrapper":"iamL5","closeButton":"V29Yn"};